<template>
  <div class="mt-0 pt-0">
    <h3 class="text-center mt-0">Lista de pre registros de marketing</h3>

    <p class="px-8 text-center">
      Aqui la contadora de sede verifica el comprobante de pago, los documentos subidos y si estan correctos procede a
      la validacion para poder inscribirlos al programa
    </p>

    <v-btn color="green" text @click="listar">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <v-data-table
      :headers="xheaders"
      :items="contactos"
      :loading="loading"
      :items-per-page="55"
      dense
      class="elevation-1">
      <template v-slot:[`item.opt`]="{ item }">
        <v-tooltip v-if="ver_val_btn" left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="purple" text @click="verificar_documentos(item)" v-bind="attrs" v-on="on">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </template>
          <span> Validar informacion contable </span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mt-1" text color="green" @click="proceder_inscripcion(item)" v-bind="attrs" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <span> Inscribir al programa </span>
        </v-tooltip>
      </template>
    </v-data-table>

    <conta_verif ref="refconta_verif" v-on:success="listar" />
  </div>
</template>

<script>
  import conta_verif from './conta_verif.vue';

  import { headers3, getPreregistros } from './utils';

  export default {
    components: {
      conta_verif,
    },
    data() {
      return {
        loading: false,
        xheaders: headers3(),
        contactos: [],
        ver_val_btn: false,
      };
    },
    watch: {
      '$store.state.CARGO': function (a) {
        if (a == null) return;
        this.listar();
      },
    },
    methods: {
      async listar() {
        this.loading = true;
        const q = {};

        const rol_id = this.$store.state.CARGO.cargo.id;
        const us_id = this.$store.state.DATA_USER.id;
        const sede_id = this.$store.state.CARGO.sede.id;
        const contas = [14,15]; // id del rol de conta
        // la contadora ve todos de la sede actual
        if (contas.includes(rol_id)) {
          q.sede_id = sede_id;
          this.ver_val_btn = true;
        } 
        // el asesor solo ve sus pre registros
        else q.asesor_id = us_id;

        // master ve todo por eso se quita el filtro por sede_id y asesor_id
        if (rol_id == 1) {
          this.ver_val_btn = true;
          delete q.sede_id;
          delete q.asesor_id;
        }

        const res = await getPreregistros(q);
        this.loading = false;
        this.contactos = res;
      },
      proceder_inscripcion(row) { 
        if (row.estado == 'PENDIENTE_VALIDACION') {
          this.$root.$notify.show('La contadora de sede todavia no dio el visto bueno', { color: 'red', x: 'right' });
          return;
        }
        this.$router.push(`/prospectos_ins/${row.programa_id}?asesor_id=${row.asesor_id}&persona_id=${row.persona_id}&persona_name=${row.persona_name}`);
      },
      verificar_documentos(row) {
        this.$refs.refconta_verif.openmodal(row);
      },
    },
    mounted() {
      this.listar();
    },
  };
</script>
